import React from 'react';
import { GWITracker } from 'gwi-tracker';
import PropTypes from 'prop-types';
import logger from '../../shared/helpers/logger';
import FrameEventService from '../../shared/services/frame-event-service';

class OverlayActionButtons extends React.Component {
  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    /*eslint-enable */
    addListClick: PropTypes.func.isRequired,
    onQueue: PropTypes.func.isRequired,
    onListMenuOpen: PropTypes.func.isRequired,
  };

  state = {
    showLists: false,
  };

  setLists = (lists) => {
    this.props.onListMenuOpen(lists);
  };

  handleListsClick = () => {
    const brickData = this.props.brickData;

    if (brickData.isLoggedIn) {
      this.props.addListClick();

      if (!brickData.userLists) {
        logger.debug("Doesn't have lists, must fetch");
        brickData.api.getLists().then((response) => {
          this.setLists(response.lists);
        });
      }
    } else {
      logger.warn('Not Logged in..');

      logger.debug('Firing Frame Messenger for Add List');

      FrameEventService.sendSignInRequired(brickData);
    }
  };

  handleQueueClick = () => {
    const brickData = this.props.brickData;

    if (brickData.isLoggedIn) {
      logger.debug('User logged in, trying to rate now..');

      if (brickData.inQueue) {
        logger.debug('This is being removed to queue');
        brickData.api.removeFromQueue(brickData.watchableType,
            brickData.watchableId).then(() => {
              // ****
              GWITracker.trackRemoveFromQueue(brickData.trackingState);
              // ****

              this.props.onQueue();
            }, (xhr, status, err) => {
              logger.error('API call to rate failed.', xhr, status, err);
            });
      } else {
        logger.debug('this is being added from queue.');
        brickData.api.addToQueue(
            brickData.watchableType, brickData.watchableId).then(() => {
              // ****
              GWITracker.trackAddToQueue(brickData.trackingState);
              // ****

              this.props.onQueue();
            }, (xhr, status, err) => {
              logger.error('API call to rate failed.', xhr, status, err);
            });
      }
    } else {
      logger.warn('Not Logged in..');

      logger.debug('Firing Frame Messenger for Queues');

      FrameEventService.sendSignInRequired(brickData);
    }
  };

  handleTrailerClick = () => {
    const brickData = this.props.brickData;
    const { trackingState, trackingOptions } = brickData;
    const youtubeUrl = `https://youtube.com/watch?v=${brickData.trailerUrl}`;

    logger.debug('Opening video with url:', youtubeUrl);

    FrameEventService.sendTrailerClicked(brickData, {
      trackingState: trackingState.toTrackingOptions(),
      youtubeUrl,
      trackingOptions,
    });
  };

  handleExternalLinkClick = () => {
    const brickData = this.props.brickData;

    GWITracker.trackExternalLinkClick(brickData.trackingState);
  };

  renderTrailerBtn() {
    if (this.props.brickData.trailerUrl) {
      return (
        <button className="action-bar-item text-center" onClick={this.handleTrailerClick}>
          <span className="gwi-brick--btn" title="View Trailer">
            <i className="fa fa-youtube-play" />
          </span>
          <span className="gwi-brick--btn-label">View Trailer</span>
        </button>
      );
    }

    return '';
  }

  render() {
    return (
      <div className="action-bar">
        { this.props.brickData.hideUserActions ? null :
        <button className="action-bar-item text-center" onClick={this.handleQueueClick}>
          <span
            className={this.props.brickData.inQueue ? 'gwi-brick--btn btn-active' : 'gwi-brick--btn'}
            title={this.props.brickData.inQueue ? 'In Queue' : 'Queue'}
          >
            {
            this.props.brickData.inQueue ?
              <i className="fa fa-check" /> : <span className="q">Q</span>
            }
          </span>
          <span className="gwi-brick--btn-label">
            {this.props.brickData.inQueue ? 'In Queue' : 'Queue It'}
          </span>
        </button>
        }

        { this.renderTrailerBtn() }

        { this.props.brickData.hideUserActions ? null :
        <button className="action-bar-item text-center " onClick={this.handleListsClick}>
          <span className="gwi-brick--btn" title="Add to List">
            <i className="fa fa-list" /></span>
          <span className="gwi-brick--btn-label">Add to List</span>
        </button>
        }

        { this.props.brickData.externalLink ?
          <a
            className="action-bar-item text-center"
            onClick={this.handleExternalLinkClick}
            href={this.props.brickData.externalLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="gwi-brick--btn" title="External Link">
              <i className="fa fa-external-link" />
            </span>
            <span className="gwi-brick--btn-label">Read More</span>
          </a> : null
        }
      </div>
    );
  }
}

export default OverlayActionButtons;



// WEBPACK FOOTER //
// ./src/client/components/overlay-action-buttons.jsx